import sortBy from "lodash/sortBy";

export const getRowItems = (currentOrder) => {
  return sortBy(getItemsInCart(currentOrder), "price").reverse();
};

/* ✅Caution✅ Need to compare git changes */
export function getItemsInCart(currentOrder) {
  let itemsInCart = [];
  let menuItems = currentOrder.menuItems
    ? JSON.parse(JSON.stringify(currentOrder.menuItems))
    : [];

  menuItems
    ?.filter((m) => !m.isVoided)
    .forEach((m) => {
      // filter out voided
      if (m.selectedSizes && m.selectedSizes.length > 0 && m.isHalf) {
        m.selectedSizes.forEach((s) => {
          if (s.quantity) {
            let qan = Number(s.quantity);
            for (let p = 0; p < qan; p = p + 0.5) {
              let cartItem = {
                primaryKey: itemsInCart.length + 1,
                _id: m._id,
                categoryId: m.categoryId,
                name: m.name,
                itemType: m.itemType,
                baseModifierId: m.baseModifierId ? m.baseModifierId : "",
                sizeKey: s._id,
                halfIndex: "",
                isHalf: true,
                isSecondHalf: m.isSecondHalf,
                price: Number(s.price),
                selectedExtraIngredients: m.selectedExtraIngredients,
                removedIngredients: m.removedIngredients,
                orderIndex: m.orderIndex,
                ...(m.specialId ? { specialId: m.specialId } : {}),
              };
              itemsInCart.push(cartItem);
            }
          }
        });
      } else if (m.selectedSizes && m.selectedSizes.length > 0 && m.isQuarter) {
        m.selectedSizes.forEach((s) => {
          if (s.quantity) {
            let qan = Number(s.quantity);
            // Can Try: for (let p = 0; p < qan; p = p + 0.25)
            for (let p = 0; p < qan; p = p + 0.25) {
              let cartItem = {
                primaryKey: itemsInCart.length + 1,
                _id: m._id,
                categoryId: m.categoryId,
                name: m.name,
                itemType: m.itemType,
                baseModifierId: m.baseModifierId ? m.baseModifierId : "",
                sizeKey: s._id,
                halfIndex: "",
                isHalf: false,
                // isSecondHalf: m.isSecondHalf,
                isQuarter: true,
                isSecondQuarter: m.isSecondQuarter,
                isThirdQuarter: m.isThirdQuarter,
                isFourthQuarter: m.isFourthQuarter,
                price: Number(s.price),
                selectedExtraIngredients: m.selectedExtraIngredients,
                removedIngredients: m.removedIngredients,
                orderIndex: m.orderIndex,
                ...(m.specialId ? { specialId: m.specialId } : {}),
              };
              itemsInCart.push(cartItem);
            }
          }
        });
      } else if (m.selectedSizes && m.selectedSizes.length > 0 && !m.isHalf && !m.isQuarter) {
        m.selectedSizes.forEach((s) => {
          if (s.quantity) {
            let qan = Number(s.quantity);
            for (let p = 0; p < qan; p = p + 1) {
              let cartItem = {
                primaryKey: itemsInCart.length + 1,
                _id: m._id,
                categoryId: m.categoryId,
                name: m.name,
                itemType: m.itemType,
                baseModifierId: m.baseModifierId ? m.baseModifierId : "",
                sizeKey: s._id,
                halfIndex: "",
                isHalf: false,
                isSecondHalf: false,
                price: Number(s.price),
                selectedExtraIngredients: m.selectedExtraIngredients,
                removedIngredients: m.removedIngredients,
                orderIndex: m.orderIndex,
                ...(m.specialId ? { specialId: m.specialId } : {}),
              };
              itemsInCart.push(cartItem);
            }
          }
        });
      }
    });

  return itemsInCart;
}
